import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col space-y-4" }
const _hoisted_2 = { key: 0 }

import { computed } from "vue";
import { useDialogsStore } from "@/store/useDialogsStore";
import ChevronDownIcon from "@/components/Icons/ChevronDownIcon.vue";
import ChevronUpIcon from "@/components/Icons/ChevronUpIcon.vue";
import TextMedium from "@/components/Texts/TextMedium.vue";
import { useCountriesStore } from "@/store/useCountriesStore";
import CountryList from "@/components/Menus/CountryList.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CountryListMenu',
  props: {
    name: {},
    dialogId: {},
    search: {}
  },
  setup(__props: any) {

const props = __props;

const countriesStore = useCountriesStore();
const dialogsStore = useDialogsStore();

const isOpen = computed<boolean>(() => {
  return dialogsStore.dialogs[props.dialogId];
});

const toggleContinentMenu = () => {
  if (dialogsStore.dialogs[props.dialogId]) {
    dialogsStore.closeOnlyOneModal(props.dialogId);
  } else {
    dialogsStore.openModalNoClosing(props.dialogId);
  }
};

const countries = computed(() => {
  let countriesList = [];
  for (const countryOnu of countriesStore.onuCountries) {
    const countryInfos = countriesStore.countries.find(
      (countriesStore) => countriesStore.code === countryOnu
    );
    if (
      countryInfos?.continent === props.name &&
      (!props.search ||
        countryInfos.name.toLowerCase().includes(props.search.toLowerCase()))
    ) {
      countriesList.push(countryInfos);
    }
  }
  return countriesList;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "flex flex-row max-h-100 overflow-y-auto",
      onClick: toggleContinentMenu,
      onTouch: toggleContinentMenu
    }, [
      _createVNode(TextMedium, {
        class: "mr-auto",
        text: props.name + '(' + countries.value.length + ')'
      }, null, 8, ["text"]),
      (isOpen.value)
        ? (_openBlock(), _createBlock(ChevronUpIcon, {
            key: 0,
            class: "ml-auto text-white mt-1"
          }))
        : (_openBlock(), _createBlock(ChevronDownIcon, {
            key: 1,
            class: "ml-auto text-white mt-1"
          }))
    ], 32),
    (isOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countries.value, (country) => {
            return (_openBlock(), _createBlock(CountryList, {
              key: country.name,
              "country-infos": country
            }, null, 8, ["country-infos"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})